import React from "react";

const PleaseContactAdmin = () => {
  return (
    <div className="container mx-auto p-4 sm:p-8 ">
      <div className="max-w-4xl mx-auto bg-green-200 p-6 sm:p-8 rounded-md shadow-md flex justify-center">
        <h2 className="text-2xl sm:text-3xl text-red-600 font-bold mb-4 sm:mb-6">
          Please Contact Your Admin
        </h2>
      </div>
    </div>
  );
};

export default PleaseContactAdmin;
